import {settings} from "../config.ts";
import axios from "axios";

export async function getReferrals (userId:string) {
    const config = {
        headers: {
            Authorization: `Bearer ${encodeURIComponent(userId)}`,
        },
    };
    try {
        const url = `${settings.url}users/refs`;

        const response = await axios.get(url, config)

        return response.data;
    } catch (e) {
        console.log("Ошибка", e)
    }
}

export async function claimRewards (userId:string) {
    const config = {
        headers: {
            Authorization: `Bearer ${encodeURIComponent(userId)}`,
        },
    };
    try {
        const url = `${settings.url}users/refs`

        const response = await axios.post(url, {}, config)
        return response.data;
    } catch (e) {
        console.log("Ошибка", e)
    }
}